/**
 * User: daletan
 * Date: 7/29/14
 * Time: 5:24 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var $ = require('dibs-jquery-shim');
var VisitorTracking = require('./core/VisitorTracking');
$(function () {
    VisitorTracking.getInstance().init();
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/nonCritical.js
// module id = 2328
// module chunks = 63